import { DocumentSnapshot, logger } from "../firestoreImports"
import { z } from "zod"

const fleetSchema = z.object({
    title: z.string().min(1)
})

interface IFleet {
    id: string
    title: string
}

export interface Fleet extends IFleet {}
export class Fleet {
    constructor(params: IFleet) {
        Object.assign(this, params)
    }

    static fromData(doc: DocumentSnapshot): Fleet | null {
        const raw = doc.data()
        if (!raw) {
            logger.warn(`Cannot create Fleet ${doc.id} from snapshot: missing data`)
            return null
        }

        try {
            const parsed = fleetSchema.parse(raw)
            return new Fleet({ id: doc.id, title: parsed.title })
        } catch (error) {
            logger.error(`Cannot create Fleet ${doc.id} from snapshot:`, error)
            return null
        }
    }

    asData(): { [k: string]: any } {
        return fleetSchema.parse({ title: this.title })
    }

    toString(): string {
        return `${this.title} (${this.id})`
    }
}
